import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb2132a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "tooltip",
  class: "tooltip"
}, null, -1))

import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTooltip',
  props: {
    text: { default: 'Текст' },
    showInMobile: { type: Boolean, default: true },
    active: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const isMobile = computed((): boolean => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
    navigator.userAgent,
  );
});
const mouseEnter = (e: MouseEvent) => {
  if (!isMobile.value && props.active) {
    let text = document.querySelector<HTMLElement>('.tooltip')!;

    text.style.display = 'flex';
    text.style.left = e.pageX + 10 + 'px';
    text.style.top = e.pageY - 20 + 'px';
    text.textContent = props.text;
  }
};
const mouseLeave = () => {
  if (!isMobile.value && props.active) {
    let text = document.querySelector<HTMLElement>('.tooltip')!;

    text.textContent = '';
    text.style.display = 'none';
  }
};

const sheet = ref(false);

const closeSheet = () => {
  let body = document.querySelector<HTMLElement>('body')!;

  if (body) {
    body.style.height = 'auto';
    body.style.width = 'auto';
    body.style.overflow = 'visible';
  }

  sheet.value = false;
};
const openSheet = () => {
  if (isMobile.value && props.showInMobile) {
    setTimeout(() => {
      let body = document.querySelector<HTMLElement>('body')!;

      if (body) {
        body.style.height = '100vh';
        body.style.width = '100vw';
        body.style.overflow = 'hidden';
      }
      sheet.value = true;
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_bottom_sheet = _resolveComponent("base-bottom-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modalWindow" }, [
      _hoisted_1
    ])),
    _createElementVNode("div", {
      class: "tooltip-slot",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openSheet())),
      onMousemove: _cache[1] || (_cache[1] = ($event: any) => (mouseEnter($event))),
      onMouseout: mouseLeave
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 32),
    _createVNode(_component_base_bottom_sheet, {
      sheet: sheet.value,
      "close-outsize": "",
      onClose: closeSheet
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.text), 1)
      ]),
      _: 1
    }, 8, ["sheet"])
  ], 64))
}
}

})